import React from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'
import Form from '_components/form/Form'

const UpdateDataFormat = (props) => {
  const { fields, schema, onChange, index, type, item, onRemove } = props

  const onItemChange = (value, name) => {
    onChange(index, value, name, type)
  }

  const removeItem = () => {
    onRemove(index, type)
  }

  return (
    <div className="sg-config-data-container">
      <Form
        key={index}
        fields={fields}
        schema={schema}
        item={item}
        onChange={onItemChange}
        className="sg-config-data-format"
      />
      <IconButton onClick={removeItem} iconProps={{ icon: 'minus', type: 'fill' }} />
    </div>
  )
}

export default UpdateDataFormat
